import React from 'react';

import { useMoveUnitOverviewItemMutation, useUpdateUnitMutation } from '../unitsApi';

import type { Unit } from '@/shared/types/unit';
import type { OverviewItem } from '@/shared/types/overview';
import type { StoredStandard } from '@/shared/types/customStandard';
import type { ReorderPlacement } from '@/shared/utils/reorder';
import { OverviewCard } from '@/features/courses/components/OverviewCard';

interface UnitOverviewCardProps {
  unit: Unit;
  canEdit: boolean;
  parentScope?: StoredStandard[];
}

export const UnitOverviewCard: React.FC<UnitOverviewCardProps> = ({
  unit,
  canEdit,
  parentScope,
}) => {
  const [updateUnit, { isLoading: isUpdating }] = useUpdateUnitMutation();
  const [moveOverviewItem] = useMoveUnitOverviewItemMutation();

  const handleMoveOverviewItem = (itemId: string, placement: ReorderPlacement) =>
    moveOverviewItem({ unitId: unit.id, itemId, placement }).unwrap();

  const handleSaveOverview = async (overview: OverviewItem[]) => {
    await updateUnit({
      id: unit.id,
      content: { ...(unit.content ?? {}), overview, schemaVersion: '1' },
    }).unwrap();
  };

  return (
    <OverviewCard
      title="Unit Overview"
      entityName="unit"
      items={unit.content?.overview ?? []}
      canEdit={canEdit}
      isUpdating={isUpdating}
      onSave={handleSaveOverview}
      onMove={handleMoveOverviewItem}
      ownerId={unit.owner_id}
      parentScope={parentScope}
      allowAllToggle
      scopeLabel="course"
      sx={{ mb: 2 }}
    />
  );
};

export default UnitOverviewCard;
